<template>
  <div>
  <div>
      <j-select-biz-component
        :value="value"
        :option="option"
        :name='this.$store.getters.language["role"]'
        :need-init-all="true"
        displayKey="roleName"
        :disabled="disabled"
        :returnKeys="returnKeys"
        :listUrl="url.list"
        :columns="columns"
        :objectId="objectId"
        :isFix="isFix"
        queryParamCode='roleCode'
        :queryParamText='this.$store.getters.language["platform.roleUser.columns.roleCode"]'
        v-on="$listeners"
        v-bind="$attrs"
      />
  </div>
    <div>
      <a-modal
        title="Title"
        :visible="visible"
        :zIndex="1005"
      />


    </div>
    <div>
      <span slot="action" slot-scope="text, record">
          <a >{{language['common.edit']}}</a>
        </span>

    </div>
    </div>

</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectRole',
    components: { JSelectBizComponent },
    props: {
      //'value','option','appId',"disabled"
      value: {
        type: String,
        default: ''
      },
      option:{
        type: Array,
        default: () => []
      },
      appId: {
        type: String,
        default: ''
      },
      objectId: {
        type: String,
        default: ''
      },
      isFix: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }

    },
    data() {
      return {
        returnKeys: ['roleName', 'id'],
        visible:false,
        url: { list: '/sys/role/list?applicationId='+this.appId },
        columns: [
          { title: this.$store.getters.language['platform.roleUser.columns.roleName'], dataIndex: 'roleName', align: 'center', width: 120 },
          { title: this.$store.getters.language['platform.roleUser.columns.roleCode'], dataIndex: 'roleCode', align: 'center', width: 120 },
          { title: this.$store.getters.language['platform.roleUser.columns.applicationName'], dataIndex: 'applicationNameLanguage', align: 'center', width: 120 },
          { title: this.$store.getters.language['common.createTime'], dataIndex: 'createTime', align: 'center', width: 120 },

        ]
      }
    }
  }
</script>

<style lang="less" scoped></style>